import 'css-chunk:src/components/widgets/Input/InputGroup.scss';export default {
  "InputGroup": "_InputGroup_gf5hd_1",
  "input": "_input_gf5hd_14",
  "prepend": "_prepend_gf5hd_19",
  "append": "_append_gf5hd_24"
};